// @flow
import React from 'react';
import { slice } from 'lodash';
import Slider from 'react-slick';
import type { Settings } from 'react-slick';
// Styles
import './BlogRecentPosts.css';
// Components
import { Link } from 'react-router-dom';
import HorizontalDivider from './HorizontalDivider';
import BlogCard from './BlogCard';
import { useScreenWidth } from '../../common';
import PaginatedScrollerSkeleton from '../../products/components/PaginatedScrollerSkeleton';

type Props = {
  posts: Post[],
};

const { innerWidth } = window;

const POSTS_PER_PAGE = innerWidth > 1150 ? 4 : innerWidth > 750 ? 3 : 1;

const SampleNextArrow = props => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={style} onClick={onClick}>
      <div className="scroller-arrow-container">
        <i
          className="fa fa-caret-right fa-4x scroller-arrow"
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

const SamplePrevArrow = props => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={style} onClick={onClick}>
      <div className="scroller-arrow-container">
        <i
          className="fa fa-caret-left fa-4x scroller-arrow"
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

const BlogRecentPosts = (props): Props => {
  const posts = props.posts || [];
  const screenWidth = useScreenWidth();
  const paginatedPosts = slice(props.posts, 0, 4);
  const settings: Settings = {
    dots: false,
    infinite: posts.length > POSTS_PER_PAGE,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    swipe: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 1150,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 750,
        settings: { slidesToShow: 1, arrows: false, dots: true },
      },
    ],
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  if (props.loading && props.posts.length === 0) {
    return <PaginatedScrollerSkeleton />;
  }

  if (screenWidth < 750) {
    return (
      <div className="blog-recent-posts-main">
        <HorizontalDivider title="Aprenda mais" />
        {props.title ? <h2>Últimas postagens</h2> : null}
        <div className="blog-recent-posts-grid">
          {paginatedPosts.map((post: any) => (
            <BlogCard key={post.slug} {...post} />
          ))}
        </div>

        <Link to="/blog" className="blog-recent-posts-load-more">
          Ver mais
        </Link>
      </div>
    );
  }

  return (
    <div className="blog-recent-posts-main">
      <HorizontalDivider title="Aprenda mais" />
      {props.title ? <h2>Últimas postagens</h2> : null}
      <Slider {...settings} className="blog-recent-posts-slider">
        {posts.map((post: any) => (
          <div key={post.slug} className="blog-recent-posts-slide">
            <BlogCard {...post} />
          </div>
        ))}
      </Slider>

      <Link to="/blog" className="blog-recent-posts-load-more">
        Ver mais
      </Link>
    </div>
  );
};

export default BlogRecentPosts;
